import { Box, Button, Typography } from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

export default function VisitStore() {
    return (
        <>
            <Box
                component="a"
                href="https://bilalabdulhadi.com"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                    mb: 2,
                    display: "block",
                    textDecoration: "none",
                    color: "inherit",
                    borderRadius: 3,
                    overflow: "hidden",
                    background: "rgba(255,255,255,0)",
                    backdropFilter: "blur(12px)",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    cursor: "pointer",
                    "&:hover": {
                        transform: "translateY(-3px)",
                        boxShadow: "0 14px 40px rgba(0,0,0,0.18)",
                    },
                }}>
                <Box
                    component="img"
                    src="/media/preview.jpg"
                    alt="Bilal Abdulhadi"
                    sx={{
                        width: "100%",
                        height: 140,
                        objectFit: "cover",
                        display: "block",
                    }}
                />

                <Box sx={{ p: 1 }}>
                    <Typography fontWeight={600}>Welcome</Typography>
                    <Typography variant="body2" sx={{ opacity: 0.7 }}>
                        Find me around the web
                    </Typography>
                </Box>
            </Box>

            <Button
                size="large"
                startIcon={<ShoppingCartIcon />}
                href="https://bilalabdulhadi.com"
                sx={{
                    borderRadius: 3,
                    py: 1.4,
                    fontWeight: 600,
                    background: "linear-gradient(90deg, #cfa14a, #f5d07b)",
                    color: "#000",
                    transition: "all 0.35s ease",
                    boxShadow: "0 6px 20px rgba(207,161,74,0.35)",

                    "&:hover": {
                        transform: "translateY(-3px) scale(1.02)",
                        boxShadow: "0 12px 35px rgba(207,161,74,0.5)",
                    },

                    "&:active": {
                        transform: "translateY(0) scale(0.98)",
                        boxShadow: "0 4px 12px rgba(207,161,74,0.25)",
                    },
                    overflow: "hidden",
                    "&::after": {
                        content: '""',
                        position: "absolute",
                        inset: 0,
                        background:
                            "radial-gradient(circle at center, rgba(255,255,255,0.35), transparent 60%)",
                        opacity: 0,
                        transition: "opacity 0.4s ease",
                    },
                    "&:hover::after": {
                        opacity: 1,
                    },
                }}>
                Visit Store
            </Button>
        </>
    );
}